export enum AtomStatusMarkerColorEnum {
  CORAL = "coral",
  CANARY = "canary",
  MINT = "mint",
  RAINY = "rainy",
}
